import $ from 'jquery'
import 'jquery-parallax.js'
import Cookies from 'js-cookie'
import consentManagement, {hasConsentGroup} from '../util/consent-management'
import jsImport from '../util/js-import'

export default {
  init() {
    // JavaScript to be fired on all pages

    // Prioritizing interactive functionality.
    $(function() {
      $('.child-toggle').on('click', function () {
        let menu = $(this);
        menu.siblings('.secondary').toggle();
        menu.toggleClass('active');
      });

      if ($('nav.main .c-menu__current-page-ancestor, nav.main .c-menu__current-menu-item.has-children')) {
        let currentMenu = $(this);
        $('nav.main .c-menu__current-page-ancestor > .child-toggle, nav.main .c-menu__current-menu-item.has-children  > .child-toggle').siblings('.secondary').toggle();
        currentMenu.addClass('active');
      }

      $('a[href*="#"]:not([href="#"])').on('click', function () {
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
          if (target.length) {
            $('html, body').animate({
              scrollTop: target.offset().top,
            }, 730);
            return false;
          }
        }
      });
    });

    $('nav.main ul li a').on('click', function() {
      $('header.headermain').toggleClass("isActive");
    });

    $(document.body).on('click', 'header.headermain .logo button', function(e){
      e.preventDefault();
      $('header.headermain').toggleClass('isActive');
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // Scripts that require consent.
    new consentManagement(() => {
      if (hasConsentGroup('performance')) {
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-P3QTMPZ');

        // Google conversion tag.
        jsImport.url('https://www.googletagmanager.com/gtag/js?id=AW-11040829280').then(() => {
          window.dataLayer = window.dataLayer || [];
          window.gtag = () => {dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'AW-11040829280');
        });

        // store locator links
        [...document.querySelectorAll('.store-locater-wrapper a[href]')].forEach(el => {
          // el.addEventListener('click', (e) => {
          //   e.preventDefault();
          //   var url = el.getAttribute('href');
          //   var callback = function () {
          //     if (typeof(url) != 'undefined') {
          //       window.location = url;
          //     }
          //     // eslint-disable-next-line
          //     console.log('url', url);
          //   };
          //   gtag('event', 'conversion', {
          //       'send_to': 'AW-11040829280/EdPeCK2t3IQYEODe1pAp',
          //       'transaction_id': '',
          //       'event_callback': callback
          //   });
          // })
        })
      }
    });

    // Age gate.
    if (!Cookies.get('ofage')) {
      /*eslint-disable */
      return import(/* webpackChunkName: "ageGate" */ '../util/ageGate').then(({ default: loadAgeGate }) => {
      /*eslint-enable */
        loadAgeGate();
      });
    }

    // Deprioritize display javascript.
    $('.page-wrapper').parallax({imageSrc: $('.page-wrapper').css('background-image').slice(4, -1).replace(/"/g, "") });
    $('.page-wrapper').css('background', 'none');
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js